
import { StdResponse, request } from "@/global/config/request";

export function startMonitoring(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/monitoring/start`, null, {
        params: {
            ...params,
        }
    })
}
export function stopMonitoring(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/monitoring/stop`, null, {
        params: {
            ...params,
        }
    })
}

export function testSensorConnect(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/test-connect`, {
        params: {
            ...params,
        }
    })
}

export function testDataBoxConnect(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/data-boxs/${dataBoxId}/test-connect`, {
        params: {
            ...params,
        }
    })
}